import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
const RefundRequest = ({ match }) => (
    <Switch>
        <Route exact path={`${match.url}/list`} component={asyncComponent(() => import('../../components/User/ListRefundRequest'))} />
        <Route exact path={`${match.url}/list/:refund_id`} component={asyncComponent(() => import('../../components/User/ListRefundRequest'))} />

    </Switch>
)

export default RefundRequest;